import { render, staticRenderFns } from "./CheckUp.vue?vue&type=template&id=32418562&scoped=true"
import script from "./CheckUp.vue?vue&type=script&lang=js"
export * from "./CheckUp.vue?vue&type=script&lang=js"
import style0 from "./CheckUp.vue?vue&type=style&index=0&id=32418562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32418562",
  null
  
)

export default component.exports